module.exports = __webpack_public_path__ + "static/media/firefox2.56ae82a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/firefox2.png
// module id = 410
// module chunks = 1